/* eslint-disable arrow-body-style */
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import {
  Tab, Tabs, Tooltip,
} from '@mui/material';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
// import { PdfFillerCore } from '@panna/pdffiller';
import { MdOutlineFileDownload, MdOutlineFileUpload } from 'react-icons/md';
import {
  getContentType,
  // getFileExtension,
} from 'src/components/elements/File/utils';
import { Loader } from 'src/components';
import axios from 'axios';
import {
  FileFormat, FileValueType,
} from 'src/components/elements/File';
import { File } from 'src/components/elements';

interface DocHTMLViewerProps {
  resumeDetails: any;
  handleUpload: (file: FileValueType) => void;
  loading: boolean;
}

function DocHTMLViewer(props: DocHTMLViewerProps) {
  const {
    resumeDetails, handleUpload, loading: parentLoading,
  } = props;
  const { htmlCode, fileURL, presignedUrl } = resumeDetails;
  const [value, setValue] = React.useState(1);
  const htmlCodeRef = React.useRef<HTMLDivElement>(null);
  const [innerHtml, setInnerHtml] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (htmlCode) {
      setLoading(true);
      axios.get(htmlCode)
        .then((res) => {
          setInnerHtml(res.data);
          if (htmlCodeRef?.current) {
            htmlCodeRef.current.innerHTML = res.data || '';
          }
        })
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [htmlCode]);

  React.useEffect(() => {
    if (value === 1) {
      if (htmlCodeRef?.current) {
        htmlCodeRef.current.innerHTML = innerHtml;
      }
    }
  }, [value, htmlCodeRef]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const onDocumentDownload = () => {
    if (value === 1) {
      window.open(htmlCode, '_blank');
    } else {
      window.open(presignedUrl, '_blank');
    }
  };

  const onDocumentView = () => {
    return (
      <div
        style={{
          display: 'flex',
          width: '600px',
          height: '80vh',
          border: '1px #4D586A solid',
        }}
      >
        <DocViewer
          documents={[{
            uri: presignedUrl,
            fileType: getContentType('', fileURL),
          }]}
          pluginRenderers={DocViewerRenderers}
          config={{
            header: {
              disableHeader: true,
              disableFileName: false,
              retainURLParams: false,
            },
          }}
        />
        {/* {getFileExtension(fileURL) === 'pdf' ? (
          <PdfFillerCore
            thumbnails
            height={78}
            pdfSource={presignedUrl || ''}
          />
        ) : (
          <DocViewer
            documents={[{
              uri: presignedUrl,
              fileType: getContentType('', fileURL),
            }]}
            config={{
              header: {
                disableHeader: true,
                disableFileName: false,
                retainURLParams: false,
              },
            }}
            pluginRenderers={DocViewerRenderers}
          />
        )} */}
      </div>
    );
  };

  const onShowHTML = () => {
    return (
      <>
        {loading && (
          <div className="fixed top-[50vh] left-[50vw]">
            <Loader />
          </div>
        )}
        {/* <div
          className="w-[600px] h-[600px] overflow-auto border-1 border-solid border-[#4D586A]"
          ref={htmlCodeRef}
        /> */}
        <iframe
          title="iframe"
          style={{
            width: '80vw',
            height: '80vh',
            transform: window.innerWidth < 1024 ? 'scale(0.8, 0.8)' : 'scale(1, 1)',
            transformOrigin: 'center top',
          }}
          className="h-full w-full border mx-auto border-solid overflow-hidden shadow-lg"
          srcDoc={innerHtml}
        />
      </>
    );
  };

  return (
    <div className="flex flex-col items-center mx-auto mt-4">
      <div className="flex justify-center items-center max-w-xl">
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{ '& .Mui-selected': { backgroundColor: '#4D586A' } }}
        >
          <Tab
            label="DOC"
            className={
              twMerge(
                'min-h-[48px] rounded font-bold normal-case text-[14px]',
                value === 0 ? 'bg-[#4D586A] text-white' : 'text-[#4D586A]',
              )
            }
          />
          <Tab
            label="HTML"
            className={
              twMerge(
                'min-h-[48px] rounded font-bold normal-case text-[14px]',
                value === 1 ? 'bg-[#4D586A] text-white' : 'text-[#4D586A]',
              )
            }
          />
        </Tabs>
      </div>
      <div className="border relative p-4 rounded-lg border-solid border-[#dedede]">
        <div className="absolute top-2 right-2 flex gap-2">
          <Tooltip title="Upload">
            <button
              type="button"
              className="cursor-pointer rounded-md items-center border-primary bg-primary"
              disabled={parentLoading}
            >
              <File
                minSize={1}
                maxSize={10000000}
                supportTypes={{
                  [FileFormat.PDF]: [],
                  [FileFormat.JPG]: [],
                  [FileFormat.PNG]: [],
                  [FileFormat.DOC]: [],
                  [FileFormat.DOCX]: [],
                  [FileFormat.TXT]: [],
                }}
                disabled={parentLoading}
                onChange={(file: FileValueType) => handleUpload(file)}
                onClose={() => {}}
              >
                <div className="flex flex-col">
                  <div className="text-white flex justify-center items-center">
                    <span>{fileURL ? 'Update Resume' : 'Upload Resume'}</span>
                    <MdOutlineFileUpload className="w-5 h-5 text-white" color="primary" />
                  </div>
                </div>
              </File>
            </button>
          </Tooltip>
          <Tooltip title="Download">
            <button
              type="button"
              className="cursor-pointer rounded-md items-center bg-transparent flex border-primary"
              onClick={() => onDocumentDownload()}
            >
              <span className="text-primary">Download</span>
              <MdOutlineFileDownload className="w-5 h-5 text-primary" color="primary" />
            </button>
          </Tooltip>
        </div>
        <div className="flex flex-col justify-center relative mt-6">
          {value === 1 ? onShowHTML() : null}
          {value === 0 ? onDocumentView() : null}
        </div>
      </div>
    </div>
  );
}

export default DocHTMLViewer;
